import { DOCUMENTS_TABLE_SIZE, DOCUMENTS_TABLE_SIZE_HOME } from "../constants";
import { useStoriesViewCtx } from "../ctx/stories-view-ctx";

/**
 * Hook that returns the appropriate table size constants based on the current view context
 */
export const useTableSizes = () => {
  const { view } = useStoriesViewCtx();
  return {
    sizes: view === "home" ? DOCUMENTS_TABLE_SIZE_HOME : DOCUMENTS_TABLE_SIZE,
    view,
  };
};
